import styled from "styled-components";

import {
  PRESS_LABEL_INFO_LIST,
  SEARCH_PRESS_LABEL_INFO_LIST,
} from "@/constants/labels.constants";
import { LabelCode } from "@/types/code.types";

export const PressTextWrapper = styled.span`
  position: relative;

  &:hover {
    .tooltip {
      display: flex;
    }
  }
`;
export const PressLabel = styled.div<{
  entity: LabelCode;
  isOpacity?: boolean;
}>`
  all: unset;
  background: ${({ entity, isOpacity }) =>
    isOpacity
      ? `${
          SEARCH_PRESS_LABEL_INFO_LIST.filter(
            (item) => item.code === entity,
          )?.[0]?.background
        }`
      : PRESS_LABEL_INFO_LIST.filter((item) => item.code === entity)?.[0]
          ?.background};

  outline: ${({ entity, isOpacity }) =>
    isOpacity
      ? `${
          SEARCH_PRESS_LABEL_INFO_LIST.filter(
            (item) => item.code === entity,
          )?.[0]?.border
        }`
      : PRESS_LABEL_INFO_LIST.filter((item) => item.code === entity)?.[0]
          ?.border};
  padding: 0;
  ${({ onClick }) => (onClick ? "cursor: pointer;" : "")}
  z-index: 20;
`;

export const LabelTooltip = styled.div<{
  entity: LabelCode;
  isEndLocation?: boolean;
  isTopLocation?: boolean;
  $contentText?: string;
}>`
  position: absolute;
  top: ${({ isTopLocation }) => (!isTopLocation ? "-3.1rem" : "2.4rem")};
  left: ${({ isEndLocation }) => !isEndLocation && "-0.2rem"};
  right: ${({ isEndLocation }) => isEndLocation && "0"};
  display: none;
  justify-content: center;
  align-items: center;
  width: max-content;
  height: 2.7rem;
  overflow: hidden;
  background: ${({ entity }) =>
    PRESS_LABEL_INFO_LIST.filter((item) => item.code === entity)?.[0]
      ?.tooltipBackground};
  border-radius: 0.4rem;
  z-index: 10;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.12),
    0px 2px 4px 0px rgba(0, 0, 0, 0.16);

  color: var(--Color-Common-Text-Interactive-Inverse, #fff);
  font-size: 1.6rem;
  font-style: normal;
  font-weight: 500;
  padding: 0 0.8rem;

  &::before {
    content: "${({ $contentText }) => $contentText}";
  }

  -webkit-user-select: none; /* Chrome, Safari, Opera */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE 10+ */
  user-select: none; /* Standard syntax */
`;
